import PartyList from "./PartyList";
export default PartyList;
